import {create} from '@github/webauthn-json';
import {
  Fab,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemSecondaryAction,
  ListItemText,
  Tooltip
} from '@material-ui/core';
/* eslint-disable max-lines-per-function */
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import {AddCircle, Delete, VpnKey} from '@material-ui/icons';
import PropTypes from 'prop-types';
import React from 'react';
import locale from '../locale/Localization';
import {
  finishRegistration,
  startRegistration
} from '../script/webauthn-service';

/**
 * EmployeeEditDialog function.
 * @param {P} props
 * @return {Function} the employee edit dialog function.
 */
export default function KeyManagamentDialog(props) {
  const handleRegister = async () => {
    console.log('Start Registration ceromony');
    const pkCredentialOptions = await startRegistration(props.employee.id);
    if (pkCredentialOptions.excludeCredentials) {
      pkCredentialOptions.excludeCredentials.map(deleteInvalidTransports);
    }
    const credential = await create({
      publicKey: pkCredentialOptions
    });

    await finishRegistration(props.employee.id, credential);
    props.refreshKeys();
  };

  const deleteInvalidTransports = (item) => {
    if (item.transports === null) {
      delete item.transports;
    }
  };

  return (
    <div>
      <Dialog
        disableBackdropClick
        maxWidth={'md'}
        aria-labelledby='form-dialog-title'
        open={props.open}
        onClose={props.handleClose}
      >
        <DialogTitle id='form-dialog-title'>
          {locale.keyManagamentDialogTitle}
        </DialogTitle>
        <DialogContent>
          <Tooltip title={locale.addKeyButton} placement='top'>
            <Fab size='small' color='default' onClick={() => handleRegister()}>
              <AddCircle />
            </Fab>
          </Tooltip>
          <List>
            {props.keys.map((securityKey, key) => {
              return (
                <ListItem key={key}>
                  <ListItemAvatar>
                    <div style={{width: 85}}>
                      {securityKey.deviceProperties.imageUrl && (
                        <img src={securityKey.deviceProperties.imageUrl} />
                      )}
                      {!securityKey.deviceProperties.imageUrl && (
                        <VpnKey style={{fontSize: 50}} />
                      )}
                    </div>
                  </ListItemAvatar>
                  <ListItemText
                    style={{marginLeft: 15, marginRight: 25}}
                    primary={
                      securityKey.deviceProperties.displayName
                        ? securityKey.deviceProperties.displayName
                        : 'Unknown Key'
                    }
                    secondary={
                      'PK: ' +
                      securityKey.publicKey +
                      ' SC: ' +
                      securityKey.signatureCount
                    }
                  />
                  <ListItemSecondaryAction>
                    <IconButton
                      onClick={() => props.handleDelete(securityKey.id)}
                      edge='end'
                      color='inherit'
                      aria-label='delete'
                    >
                      <Delete color='inherit' />
                    </IconButton>
                  </ListItemSecondaryAction>
                </ListItem>
              );
            })}
          </List>
          {props.keys.length === 0 && <div>{locale.noKeysRegistered}</div>}
        </DialogContent>
        <DialogActions>
          <Button onClick={props.handleClose} color='primary'>
            {locale.cancelButton}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

KeyManagamentDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  employee: PropTypes.object,
  keys: PropTypes.array.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleDelete: PropTypes.func.isRequired,
  refreshKeys: PropTypes.func.isRequired
};
